import { msg } from "@lingui/core/macro";

export const emailIsRequiredRuleMessages = {
	name: msg({ message: "Email is required" }),
	description: msg({ message: "Parker must provide an email when registering" }),
	errors: {
		empty: msg({ message: "Email is required" }),
	},
} as const;
